<template>
  <div class="app-container">
    <div class="screeBox">
      <!--  <el-select
        filterable
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>-->
      <!-- <el-input
        class="screenInput"
        v-model="screen.username"
        placeholder="请输入用户登录名"
      ></el-input>
      <el-input
        class="screenInput"
        v-model="screen.phone"
        placeholder="请输入手机号"
      ></el-input> -->
      <!-- <el-select
        filterable
        class="screenInput"
        v-model="screen.organ_type"
        placeholder="请选择组织"
      >
        <el-option label="全部组织" value=""></el-option>
        <el-option label="园区组织" value="1"></el-option>
        <el-option label="企业组织" value="2"></el-option>
        <el-option label="住宅组织" value="3"></el-option>
        <el-option label="孵化器组织" value="4"></el-option>
        <el-option label="青云里会议室" value="5"></el-option>
      </el-select> -->
      <el-input
        class="screenInput"
        v-model="screen.like"
        placeholder="请输入组织名称，模糊搜索"
      ></el-input>
      <el-button
        size="medium"
        type="primary"
        @click="(screen.page = 1), fetchData()"
        >筛选</el-button
      >
      <el-button size="medium" type="primary" plain @click="chongZhi()"
        >重置</el-button
      >
    </div>
    <!-- <div style="margin-top: 20px">
      <el-button
        size="medium"
        type="primary"
        @click="addMenu(0)"
        v-if="roles.includes('/device/add_organ')"
        >添加硬件组织</el-button
      >
      <el-button
        size="medium"
        type="danger"
        @click="delOrgan()"
        v-if="roles.includes('/device/del_organ')"
        >删除硬件组织</el-button
      >
    </div> -->

    <el-table
      max-height="700"
      v-loading="listLoading"
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column type="selection" width="55" :selectable="selectable">
      </el-table-column>
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column label="组织名称	" width="200">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="组织唯一标识" align="center" width="200">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.organization_num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="园区名称" align="center">
        <template slot-scope="scope">
          <div class="line2" v-if="scope.row.park">
            {{ scope.row.park.name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="厂商唯一标识" align="center" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.manufacturer_num }}</span>
        </template>
      </el-table-column>
      <el-table-column label="组织类型" align="center">
        <template slot-scope="scope">
          <span>{{
            scope.row.organ_type == 1
              ? "园区组织"
              : scope.row.organ_type == 2
              ? "企业组织"
              : scope.row.organ_type == 3
              ? "住宅组织"
              : scope.row.organ_type == 4
              ? "孵化器组织"
              : scope.row.organ_type == 5
              ? "青云里会议室"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column class-name="status-col" label="Status" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="250" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleSee(scope.row)"
            v-if="roles.includes('/device/organ_info')"
            >查看</el-button
          >
          <!-- <el-button
            size="mini"
            type="success"
            @click="handleEdit(scope.row)"
            v-if="roles.includes('/device/edit_organ')"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.row.id)"
            v-if="roles.includes('/device/del_organ')"
            >删除</el-button
          > -->
          <el-button
            size="mini"
            type="primary"
            @click="devices(scope.row)"
            v-if="roles.includes('/device/select_devices')"
            >编辑门禁服务</el-button
          >
          <!-- <div style="margin-top: 10px">
            <el-button
              style="background: #00b0ff; border: #00b0ff"
              size="mini"
              type="primary"
              @click="users(scope.row)"
              v-if="roles.includes('/device/user_lists')"
              >组织人员</el-button
            >
          </div> -->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="750px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="czType != 'add' || userInfo.park_id != 0"
            @change="parkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="硬件厂商" prop="manufacturer_num">
          <el-select
            filterable
            v-model="ruleForm.manufacturer_num"
            placeholder="请选择硬件厂商"
            :disabled="czType != 'add'"
          >
            <el-option
              :label="item.name"
              :value="item.unique_num"
              v-for="(item, index) in manufacturerList"
              :key="index"
              >{{ item.name }}</el-option
            >
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="组织类型" prop="organ_type">
          <el-radio-group
            v-model="ruleForm.organ_type"
            :disabled="czType != 'add' || !ruleForm.park_id"
            @change="typeRadio"
          >
            <el-radio :label="1">园区组织</el-radio>
            <el-radio :label="2">企业组织</el-radio>
            <el-radio :label="3">住宅组织</el-radio>
            <el-radio :label="4">孵化器组织</el-radio>
          </el-radio-group>
        </el-form-item> -->

        <el-form-item
          label="权限"
          prop="source_id"
          v-if="ruleForm.organ_type == 2 || ruleForm.organ_type == 1"
        >
          <el-select
            filterable
            v-model="ruleForm.source_id"
            placeholder="请选择权限"
            :disabled="czType != 'add'"
            @change="sourceChange"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in sourceList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="楼栋"  v-if="ruleForm.organ_type == 3">
          <el-select
            filterable
            v-model="ruleForm.ld_id"
            placeholder="请选择楼栋"
            @change="ldChange"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in ldList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="房屋楼层" v-if="ruleForm.organ_type == 3">
          <el-select
            filterable
            :disabled="czType != 'add'"
            v-model="ruleForm.source_id"
            placeholder="请选择房屋楼层"
            @change="sourceChange"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="(item, index) in ldList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="硬件组织名称" prop="name">
          <el-input
            v-model="ruleForm.name"
            :disabled="czType == 'see'"
            placeholder="请输入硬件组织名称"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="czType == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="primary"
            @click="editForm('ruleForm')"
          >
            修改
          </el-button>
          <el-button
            v-if="czType == 'edit'"
            type="info"
            @click="drawer = false"
          >
            取消
          </el-button>
          <el-button v-if="czType == 'add'" type="info" @click="drawer = false"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      width="650px"
      title="开通门禁服务"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="devicesForm"
        label-width="150px"
        :rules="devicesRules"
        style="max-height: 500px; overflow: auto"
      >
        <el-form-item
          label="门禁授权"
          prop="deviceGuids"
          v-if="false"
        >
          <el-select
            v-model="devicesForm.deviceGuids"
            filterable
            collapse-tags
            multiple
            reserve-keyword
            @change="handleSelect"
            @visible-change="selectSeeChannel"
            :filter-method="filter"
            placeholder="请选择门禁授权"
            class="mr10 w300"
          >
            <!-- :filter-method="filter" -->
            <div style="padding: 0 20px; line-height: 34px">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
            </div>
            <el-checkbox-group v-model="devicesForm.deviceGuids">
              <el-option
                v-for="(item, index) in devicesList"
                :label="item.name"
                :value="item.deviceGuid"
                :key="index"
              >
                <el-checkbox
                  style="pointer-events: none"
                  :label="item.deviceGuid"
                  >{{ item.name }}</el-checkbox
                >
              </el-option>
            </el-checkbox-group>
          </el-select>
        </el-form-item>
        <el-form-item label="服务有效开始时间" prop="service_start_date">
          <el-date-picker
            v-model="devicesForm.service_start_date"
            type="date"
            :value-format="timestamp"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务有效结束时间" prop="service_end_date">
          <el-date-picker
            v-model="devicesForm.service_end_date"
            :value-format="timestamp"
            type="date"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="服务有效时间段" prop="time">
          <el-time-picker
            is-range
            v-model="devicesForm.time"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm"
            format="HH:mm"
            placeholder="选择时间范围"
            @click="$forceUpdate()"
          >
          </el-time-picker>
        </el-form-item> -->
        <div v-if="devicesForm.manufacturer_num == 'jiexun'">
          <el-form-item label="有效星期" prop="service_week">
            <!-- <el-input maxlength="7" v-model="devicesForm.service_week"></el-input>
            <span style="color: #909399;">默认"1111111"每一个字节依次代表周一至周日，'1'代表有效，'0'无效</span> -->
            <el-checkbox
              v-model="item.checked"
              v-for="(item, index) in weekLists"
              :label="item.title"
              :key="index"
            ></el-checkbox>
          </el-form-item>
        </div>
        <!-- @change="
                (deviceGuid) => {
                  tkChange(deviceGuid, index);
                }" -->
        <div
         
        >
          <el-form-item label="梯控授权">
            <div
              v-for="(item, index) in devicesForm.deviceTikongs"
              :key="index"
            >
              <el-select
                filterable
                v-model="item.deviceGuids"
                placeholder="请选择梯控"
                @change="tkChange($event, index)"
              >
                <el-option
                  :disabled="
                    tikongIds.indexOf(tkItem.deviceGuid) != -1 ? true : false
                  "
                  :label="tkItem.name"
                  :value="tkItem.deviceGuid"
                  v-for="(tkItem, tkIndex) in tikongList"
                  :key="tkIndex"
                ></el-option>
              </el-select>
              <el-select
                multiple
                collapse-tags
                filterable
                v-model="item.floors"
                placeholder="请选择开通楼层"
                @change="$forceUpdate()"
              >
                <el-option
                  :label="floorsItem.name"
                  :value="floorsItem.floor"
                  v-for="(floorsItem, floorsIndex) in floorsList[index]"
                  :key="floorsIndex"
                ></el-option>
              </el-select>
              <i
                class="el-icon-delete"
                style="margin-left: 10px"
                @click.prevent="delDeviceTikongs(index)"
              ></i>
            </div>
            <el-button type="primary" size="small" @click="addDeviceTikongs()"
              >添加</el-button
            >
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDevices()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- <el-drawer
    custom-class="demo-drawer"
  title="我是标题"
  :visible.sync="dialogFormVisible"
  direction="rtl"
  size="800px"
  :before-close="handleClose">
  <div class="demo-drawer__content">
    <el-form :model="devicesForm" label-width="150px" :rules="devicesRules" style="max-height: 500px;overflow: auto;">
        <el-form-item label="门禁授权" prop="deviceGuids">
        
          <el-cascader
          style="width: 300px;"
          :show-all-levels="false"
          collapse-tags
    clearable
    v-model="devicesForm.deviceGuids"
    :options="csdevicesList"
    :props="{ multiple: true, label: 'name',
                value: 'deviceGuid', children: 'nodes' }"
    filterable
    ></el-cascader>
        </el-form-item>
        <el-form-item label="服务有效开始时间" prop="service_start_date">
          <el-date-picker
            v-model="devicesForm.service_start_date"
            type="date"
            :value-format="timestamp"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务有效结束时间" prop="service_end_date">
          <el-date-picker
            v-model="devicesForm.service_end_date"
            :value-format="timestamp"
            type="date"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="服务有效时间段" prop="time">
          <el-time-picker
            is-range
            v-model="devicesForm.time"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm"
            placeholder="选择时间范围"
            @click="$forceUpdate()"
          >
          </el-time-picker>
        </el-form-item>
        <div v-if="devicesForm.manufacturer_num == 'jiexun'">
          <el-form-item label="有效星期" prop="service_week">
           <el-checkbox
              v-model="item.checked"
              v-for="(item, index) in weekLists"
              :label="item.title"
              :key="index"
            ></el-checkbox>
          </el-form-item>
        </div>
        <div v-if="devicesForm.manufacturer_num == 'fushi'">
          <el-form-item label="梯控授权">
            <div
              v-for="(item, index) in devicesForm.deviceTikongs"
              :key="index"
            >
              <el-select
                filterable
                v-model="item.deviceGuids"
                placeholder="请选择梯控"
                @change="tkChange($event, index)"
              >
                <el-option
                  :disabled="
                    tikongIds.indexOf(tkItem.deviceGuid) != -1 ? true : false
                  "
                  :label="tkItem.name"
                  :value="tkItem.deviceGuid"
                  v-for="(tkItem, tkIndex) in tikongList"
                  :key="tkIndex"
                ></el-option>
              </el-select>
              <el-select
                multiple
                collapse-tags
                filterable
                v-model="item.floors"
                placeholder="请选择开通楼层"
                @change="$forceUpdate()"
              >
                <el-option
                  :label="floorsItem.name"
                  :value="floorsItem.floor"
                  v-for="(floorsItem, floorsIndex) in floorsList[index]"
                  :key="floorsIndex"
                ></el-option>
              </el-select>
              <i
                class="el-icon-delete"
                style="margin-left: 10px"
                @click.prevent="delDeviceTikongs(index)"
              ></i>
            </div>
            <el-button type="primary" size="small" @click="addDeviceTikongs()"
              >添加</el-button
            >
          </el-form-item>

        </div>
      </el-form>
        <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDevices()">确 定</el-button>
      </div>
  </div>
</el-drawer> -->
    <el-drawer
      title="硬件组织人员"
      :visible.sync="usersDrawer"
      direction="rtl"
      :before-close="handleClose"
      size="600px"
    >
      <div style="padding: 10px">
        <el-button
          type="primary"
          size="medium"
          @click="addUsers()"
          v-if="roles.includes('/device/add_users')"
          >添加人员</el-button
        >
        <el-table :data="usersData">
          <el-table-column
            property="name"
            label="姓名"
            width="200"
          ></el-table-column>
          <el-table-column
            property="phone"
            label="手机号"
            width="150"
          ></el-table-column>

          <el-table-column
            property="unique_num"
            label="用户硬件唯一标识"
            width="150"
          >
            <template slot-scope="scope">
              <div class="line2" v-if="scope.row.unique_num">
                {{ scope.row.unique_num }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="usersSizeChange"
          @current-change="usersCurrentChange"
          :current-page="usersForm.usersPage_size"
          :page-sizes="[15, 30, 50]"
          :page-size="usersForm.usersPage_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="usersTotal"
          style="margin-top: 10px"
        >
        </el-pagination>
      </div>
    </el-drawer>
    <el-dialog title="添加硬件组织人员" :visible.sync="usersFormVisible">
      <el-form :model="usersForm" label-width="150px" :rules="devicesRules">
        <el-form-item label="选择的人员" prop="user_id">
          <el-select
            multiple
            collapse-tags
            filterable
            v-model="usersForm.user_id"
            placeholder="请选择人员"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in deviceList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="usersFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  organLists,
  addOrgan,
  editOrgan,
  delOrgan,
  organInfo,
  selectDevices,
  userLists,
  addUsers,
  get_manufacturers,
  get_source_rel,
  get_all_devices,
  get_device_users,
  get_tikong_floors,
} from "@/api/device";
import { openPark } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger",
      };
      return statusMap[status];
    },
  },
  data() {
    return {
      weekLists: [
        {
          title: "星期一",
          checked: true,
        },
        {
          title: "星期二",
          checked: true,
        },
        {
          title: "星期三",
          checked: true,
        },
        {
          title: "星期四",
          checked: true,
        },
        {
          title: "星期五",
          checked: true,
        },
        {
          title: "星期六",
          checked: true,
        },
        {
          title: "星期日",
          checked: true,
        },
      ],
      timestamp: "yyyy-MM-dd",
      dialogFormVisible: false,
      devicesForm: {},
      checkAll: false, //招标阶段 是否全选
      isIndeterminate: false, //全选复选框标识
      timer: null,
      devicesList: [],
      devicesListAll: [],
      channels: [],
      total: 0,
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加硬件组织",
      token: getToken(),
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        type: "",
        like: "",
      },
      ruleForm: {
        name: "",
        park_id: "",
        manufacturer_num: "",
        type: 1,
        source_id: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入硬件组织名称", trigger: "blur" },
        ],
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        manufacturer_num: [
          { required: true, message: "请选择硬件厂商", trigger: "change" },
        ],
        // status: [{ required: true, message: "请选择状态", trigger: "change" }],
        source_id: [
          { required: true, message: "请选择权限", trigger: "change" },
        ],
        organ_type: [
          { required: true, message: "请选择组织类型", trigger: "change" },
        ],
      },
      multipleSelection: [],
      czType: "",
      parkList: [],
      sourceList: [],
      manufacturerList: [],
      devicesRules: {
        service_week: [
          { required: true, message: "请输入有效星期", trigger: "blur" },
        ],
        deviceGuids: [
          { required: true, message: "请选择门禁授权", trigger: "change" },
        ],
        service_start_date: [
          { required: true, message: "请选择有效开始时间", trigger: "change" },
        ],
        // status: [{ required: true, message: "请选择状态", trigger: "change" }],
        service_end_date: [
          { required: true, message: "请选择有效结束时间", trigger: "change" },
        ],
        time: [
          { required: true, message: "请选择服务时间段", trigger: "change" },
        ],
      },

      usersFormVisible: false,
      usersForm: {},
      usersDrawer: false,
      usersData: [],
      // usersPage: 1,
      // usersPage_size: 15,
      usersTotal: 0,
      deviceList: [],
      tikongList: [],
      floorsList: [],
      tikongIds: [],
      ldList: [],
      floorList: [],
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getpark();
  },
  methods: {
    // 下拉框选择事件
    handleSelect(value) {
      let filterArray = [];
      let arr = value || [];
      filterArray = this.devicesList.filter(function (item) {
        return arr.indexOf(item.deviceGuid) != -1;
      });
      this.checkAll = filterArray.length === this.devicesList.length;
      this.isIndeterminate =
        filterArray.length > 0 && filterArray.length < this.devicesList.length;
    },
    // 全选事件
    handleCheckAllChange(val) {
      const data = this.devicesList.map((item) => {
        return item.deviceGuid;
      });
      let arr = [];
      let newArray = [];
      if (val == true) {
        arr = Array.from(new Set([...this.devicesForm.deviceGuids, ...data]));
      } else {
        newArray = this.devicesForm.deviceGuids.filter(function (item) {
          return data.indexOf(item) == -1;
        });
      }
      this.devicesForm.deviceGuids = val ? arr : newArray;
      this.isIndeterminate = false;
    },
    // 打开隐藏下拉框事件
    selectSeeChannel(e) {
      if (e == false) {
        this.filter("");
      }
    },
    //自定搜索，加上防抖
    filter(v) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        //对绑定数据赋值
        this.devicesList = this.devicesListAll.filter((item) => {
          //如果直接包含输入值直接返回true
          if (item.name.indexOf(v) !== -1) return true;
        });
        let filterArray = [];
        let arr = this.devicesForm.deviceGuids || [];
        filterArray = this.devicesList.filter(function (item) {
          return arr.indexOf(item.deviceGuid) != -1;
        });
        if (filterArray.length == this.devicesList.length) {
          this.checkAll = true;
          this.isIndeterminate = false;
        } else {
          this.checkAll = false;
          if (filterArray.length > 0) {
            this.isIndeterminate = true;
          } else {
            this.isIndeterminate = false;
          }
        }
      }, 300); // 设置时间
    },
    // 添加梯控数据
    addDeviceTikongs() {
      this.tikongIds = [];
      this.devicesForm.deviceTikongs.push({
        deviceGuids: "",
        floors: [],
      });
    },
    // 删除
    delDeviceTikongs(index) {
      this.tikongIds = [];
      var i = this.tikongIds.findIndex((item) => {
        return item == this.tikongList[index].deviceGuid;
      });
      if (i != -1) {
        this.tikongIds.splice(i, 1);
      }
      this.tikongList.splice(index, 1);
      this.devicesForm.deviceTikongs.splice(index, 1);
    },
    // 梯控选择方法
    tkChange(deviceGuid, index, type) {
      var that = this;
      if (type != "info") {
        this.devicesForm.deviceTikongs[index] = {
          deviceGuids: deviceGuid,
          floors: [],
        };
      }

      this.tikongIds = [];
      this.devicesForm.deviceTikongs.forEach((item, index) => {
        if (item.deviceGuids) {
          this.tikongIds.push(item.deviceGuids);
        }
      });
      this.tikongList.forEach((item) => {
        if (deviceGuid == item.deviceGuid) {
          that.getFloors(item.device_no, index);
        }
      });
      this.$forceUpdate();
    },
    // 获得当前梯控设备具体的楼层信息
    getFloors(device_no, index) {
      let data = {
        park_id: this.devicesForm.park_id,
        device_no: device_no,
        manufacturer: this.devicesForm.manufacturer_num,
        index: index,
        type: this.devicesForm.organ_type == 3 ? 2 : 1,
      };
      get_tikong_floors(data).then((res) => {
        this.$set(this.floorsList, index, res.data);
      });
    },
    confirm() {
      var that = this;
      let data = {
        park_id: this.usersForm.park_id,
        manufacturer_num: this.usersForm.manufacturer_num,
        user_ids: this.usersForm.user_id.join(),
        organ_id: this.usersForm.organ_id,
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
      addUsers(data).then((res) => {
        loading.close();
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          that.usersFormVisible = false;
          that.getUserList();
        }
      });
    },
    // 添加用户
    addUsers() {
      let data = {
        park_id: this.usersForm.park_id,
        manufacturer_num: this.usersForm.manufacturer_num,
      };
      get_device_users(data).then((res) => {
        this.deviceList = res.data;
      });
      this.usersForm.user_id = [];
      this.usersFormVisible = true;
    },
    users(val) {
      this.usersDrawer = true;
      this.usersForm = {
        park_id: val.park_id,
        manufacturer_num: val.manufacturer_num,
        user_id: [],
        organ_id: val.id,
        usersPage: 1,
        page_size: 15,
      };
      this.getUserList();
    },
    // 获取用户
    getUserList() {
      let data = {
        park_id: this.usersForm.park_id,
        manufacturer_num: this.usersForm.manufacturer_num,
        organ_id: this.usersForm.organ_id,
        page: this.usersForm.usersPage,
        is_page: 1,
        page_size: this.usersForm.usersPage_size,
      };
      userLists(data).then((res) => {
        this.usersData = res.data.data;
        this.usersTotal = res.data.total;
      });
    },
    // 用户分页
    usersSizeChange(val) {
      this.usersForm.usersPage_size = val;
      this.usersForm.usersPage = 1;
      this.getUserList();
    },
    usersCurrentChange(val) {
      this.usersForm.usersPage = val;
      this.getUserList();
    },
    // 开通门禁服务
    onDevices() {
      console.log('开通服务')
      // return
      let service_week = [];
      // this.weekLists.forEach((item) => {
      //   if (item.checked) {
      //     service_week.push(1);
      //   } else {
      //     service_week.push(0);
      //   }
      // });
      let deviceTikong = [];
      if (this.devicesForm.deviceTikongs) {
        this.devicesForm.deviceTikongs.forEach((item, index) => {
          deviceTikong.push({
            deviceGuids: item.deviceGuids,
            floors: item.floors.join(),
          });
        });
      }
 console.log(this.devicesForm,'111开通服务')
      // return
      let data = {
        id: this.devicesForm.id,
        deviceGuids: this.devicesForm.deviceGuids.join(),
        service_start_date: this.devicesForm.service_start_date,
        service_end_date: this.devicesForm.service_end_date,
        service_start_time: this.devicesForm.time ? this.devicesForm.time[0] : "",
        service_end_time: this.devicesForm.time ? this.devicesForm.time[1] : "",
        service_week: '',
        deviceTikongs: JSON.stringify(deviceTikong),
      };
       console.log(data,'55555开通服务')
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
      });
      selectDevices(data).then((res) => {
        loading.close();
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.dialogFormVisible = false;
        }
      });
    },
    // 打开开通门禁服务
    async devices(val) {
      // this.csdrawer = true;
      // this.getInfo(val.id, "menJin");
      // await this.getAllDevices(val.id, "door");
      // return
      this.checkAll = false; //招标阶段 是否全选
      this.isIndeterminate = false; //全选复选框标识
      this.devicesForm = {
        id: val.id,
        deviceGuids: [],
        service_week: "",
        service_end_time: "",
        service_start_time: "",
        time: null,
        park_id: val.park_id,
        deviceTikongs: [
          {
            deviceGuids: "",
            floors: "",
          },
        ],
        organ_type: val.organ_type,
      };
      console.log(val)
      // if (val.manufacturer_num == "jiexun") {
      //   await this.getAllDevices(val.id, "door");
      // } else if (val.manufacturer_num == "fushi") {
      //   await this.getAllDevices(val.id, "door");
      //   this.getAllDevices(val.id, "tikong");
      // } else if (val.manufacturer_num == "weilai") {
      //   this.getAllDevices(val.id, "tikong");
      // }
      this.getAllDevices(val.id, "tikong");
      
      // if (val.manufacturer_num == "fushi") {
      //   this.getAllDevices(val.id, "tikong");
      // }

      setTimeout(() => {
        this.getInfo(val.id, "menJin", val.organ_type);
      }, 500);
      this.dialogFormVisible = true;
    },
    // 获取硬件列表
    getAllDevices(id, type) {
      get_all_devices({ id: id, device_type: type }).then((res) => {
        if (type == "door") {
          this.devicesList = res.data;
          this.devicesListAll = res.data;
          // this.csdevicesList[0].nodes = res.data
        } else if (type == "tikong") {
          this.tikongList = res.data;
        }
        this.dialogFormVisible = true;
      });
    },
    // 选择硬件厂商
    sourceChange(e) {
      this.sourceList.forEach((item) => {
        if (e == item.id) {
          this.ruleForm.name = item.name;
        }
      });
    },
    chongZhi() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        type: "",
        like: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    typeRadio(e) {
      this.ruleForm.source_id;
      this.getSource(e, "radio");
      // if (e == 3) {
      // } else {
      //   this.ruleForm.park_id = "";
      // }
    },
    ldChange(e) {
      this.getSource(e, "change");
    },
    getSource(val, type) {
      var data = {};
      if (type == "radio") {
        data = {
          park_id: this.ruleForm.park_id,
          organ_type: this.ruleForm.organ_type,
        };
      } else if (type == "change") {
        data = {
          park_id: this.ruleForm.park_id,
          organ_type: this.ruleForm.organ_type,
          father_id: val,
        };
      }
      get_source_rel(data).then((res) => {
        if (type == "radio") {
          if (val == 1 || val == 2) {
            this.sourceList = res.data;
          } else {
            this.ldList = res.data;
          }
        } else {
          this.floorList = res.data;
        }
      });
    },
    selectable(row, index) {
      if (row.id != this.userInfo.id) {
        return true;
      }
    },
    parkChange(e) {
      this.ruleForm.manufacturer_num = "";
      this.ruleForm.name = "";
      this.ruleForm.organ_type = "";
      // this.ruleForm.type = "";
      this.getManufacturer(e);
    },
    getManufacturer(parkId) {
      get_manufacturers({ park_id: parkId }).then((res) => {
        this.manufacturerList = res.data;
      });
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 修改
    editForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              if (that.ruleForm.organ_type == 4) {
                that.ruleForm.source_id = 0;
              }
              editOrgan(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: "编辑成功",
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 编辑
    handleEdit(val) {
      this.czType = "edit";
      this.drawerTitle = "编辑硬件组织";
      this.getManufacturer(val.park_id);
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.ruleForm.id = val.id

      setTimeout(() => {
        this.getInfo(val.id, "", val.organ_type);
      }, 500);

      this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看硬件组织";
      // this.ruleForm.type = val.type;
      // this.ruleForm = val
      this.getManufacturer(val.park_id);
      // this.ruleForm = JSON.parse(JSON.stringify(val))
      // this.getSource(val.type)
      setTimeout(() => {
        this.getInfo(val.id, "", val.organ_type);
        this.drawer = true;
      }, 500);
    },
    getInfo(id, type, organ_type) {
      var that = this;
      organInfo({ id: id, organ_type: organ_type }).then((res) => {
        if (type == "menJin") {
          this.devicesForm.deviceGuids = res.data.info.all_service;
          this.devicesForm.manufacturer_num = res.data.info.manufacturer_num;
          this.devicesForm.organ_type = res.data.info.organ_type;
          this.devicesForm.deviceTikongs = [];
          if (res.data.info.all_tikongs) {
            res.data.info.all_tikongs.forEach((item, index) => {
              this.devicesForm.deviceTikongs.push({
                floors: item.floor.split(","),
                deviceGuids: item.devguid,
              });
              that.tkChange(item.devguid, index, "info");
            });
          }

          if (res.data.info.config) {
            let time = [];
            time[0] = res.data.info.config.service_start_time;
            time[1] = res.data.info.config.service_end_time;
            this.$set(this.devicesForm, "time", time);
            this.$set(
              this.devicesForm,
              "service_start_date",
              res.data.info.config.service_start_date
            );
            this.$set(
              this.devicesForm,
              "service_end_date",
              res.data.info.config.service_end_date
            );
            this.devicesForm.service_week = res.data.info.config.service_week;
          }
          // this.getSource();
          // this.devicesForm.service_end_time = res.data.info.config ? res.data.info.config.service_end_time : '';
          // this.devicesForm.service_start_time = res.data.info.config? res.data.info.config.service_start_time : '';
          // this.devicesForm.service_week = res.data.info.config? res.data.info.config.service_week : '1111111';
        } else {
          this.ruleForm = {
            id: res.data.info.id,
            park_id: res.data.info.park_id,
            manufacturer_num: res.data.info.manufacturer_num,
            organ_type: res.data.info.organ_type,
            source_id: res.data.info.source_id,
            name: res.data.info.name,
          };

          if (res.data.info.organ_type == 3) {
            this.ruleForm.ld_id = "";
            // this.getSource(res.data.info.organ_type,'change');
          }
        }
        this.getSource(res.data.info.organ_type, "radio");
        // this.getSource(res.data.info.type);
      });
    },
    // 删除
    handleDelete(id) {
      var that = this;
      this.$confirm("确认删除？")
        .then(() => {
          delOrgan({ ids: id }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch(() => {});
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              // that.ruleForm.manufacturer_num = that.ruleForm.manufacturer.unique_num
              if (that.ruleForm.organ_type == 4) {
                that.ruleForm.source_id = 0;
              }
              addOrgan(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: "提交成功",
                    type: "success",
                  });
                  that.drawer = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            // this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    addMenu(id) {
      this.drawerTitle = "添加硬件组织";
      this.czType = "add";
      this.ruleForm = {
        park_id: "",
        manufacturer_num: "",
        organ_type: "",
        source_id: "",
        name: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.ruleForm.park_id = this.userInfo.park_id;
        this.parkChange(this.userInfo.park_id);
      }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
      this.drawer = true;
    },
    // 获取园区
    getpark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    delOrgan() {
      var that = this;
      var ids = [];
      if (this.multipleSelection.length) {
        this.multipleSelection.forEach((item, index) => {
          ids.push(item.id);
        });
      } else {
        this.$message.error("至少选择一个组织");
        return;
      }
      this.$confirm("确认删除？")
        .then((_) => {
          delOrgan({ ids: ids.toString(",") }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      organLists(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.w300 {
  width: 300px;
}
.head {
  display: flex;
  flex-wrap: wrap;
  .btn {
    display: inline-block;
  }
}
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}

.table-box {
  margin-top: 20px;
}
.avatar-uploader {
  width: 60px;
  height: 60px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 70px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
::v-deep .el-cascader-menu {
  max-width: 250px !important;
}
</style>
